<template>
    <div class="card shadow-sm">
      <div class="card-header bg-primary text-white">
        <i class="fas fa-chart-bar me-2"></i> Inscriptions par mois
      </div>
      <div class="card-body">
        <canvas ref="chartCanvas"></canvas>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref } from 'vue';
  import Chart from 'chart.js/auto';
  import axios from 'axios';
  
  export default defineComponent({
    name: 'UserRegistrationChart',
    setup() {
      const chartCanvas = ref<HTMLCanvasElement | null>(null);
      let chart: Chart | null = null;
  
      const loadChart = async () => {
        try {
          const response = await axios.get('/api/stats/inscriptions-par-mois');
          const data = response.data;
  
          const labels = data.map((item: any) => item.month);
          const counts = data.map((item: any) => item.count);
  
          if (chart) chart.destroy(); // Recreate chart to avoid duplicates
  
          chart = new Chart(chartCanvas.value as HTMLCanvasElement, {
            type: 'bar',
            data: {
              labels,
              datasets: [{
                label: 'Inscriptions',
                data: counts,
                backgroundColor: 'rgba(13, 110, 253, 0.7)',
                borderColor: 'rgba(13, 110, 253, 1)',
                borderWidth: 1
              }]
            },
            options: {
              responsive: true,
              plugins: {
                legend: {
                  display: false
                },
                tooltip: {
                  callbacks: {
                    label: (ctx) => `${ctx.parsed.y} inscription(s)`
                  }
                }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Nombre d’inscriptions'
                  }
                },
                x: {
                  title: {
                    display: true,
                    text: 'Mois'
                  }
                }
              }
            }
          });
        } catch (error) {
          console.error('Erreur de chargement des données :', error);
        }
      };
  
      onMounted(loadChart);
  
      return { chartCanvas };
    }
  });
  </script>
  
  <style scoped>
  canvas {
    max-width: 100%;
  }
  </style>
  